// components/Clients.js
import React from 'react';

const Clients = () => {
  // Map client names to their logo filenames
  const clients = [
    { name: "UNFPA", logo: "UNFPA.png" },
    { name: "Development Fund of Norway", logo: "Development Fund of Norway.png" },
    { name: "Christian AID", logo: "Christian AID.png" },
    { name: "Elizabeth Grazer Aids Foundation", logo: "Elizabeth Grazer Aids Foundation.png" },
    { name: "Kasupe Trust", logo: "Kasupe Trust.png" },
    { name: "MedHealth", logo: "MedHealth.png" },
    { name: "Total Land care", logo: "Total Land care.png" },
    { name: "Malawi Government", logo: "Malawi Government.png" },
    { name: "Sunbird", logo: "Sunbird.png" },
    { name: "Kids OR Organization", logo: "Kids OR Organization.png" },
    { name: "VSO", logo: "VSO.png" },
    { name: "Care International", logo: "Care International.png" },
    { name: "GIZ", logo: "GIZ.png" },
    { name: "Baylor International", logo: "Baylor International.png" },
    { name: "Eagles Relief & Development", logo: "Eagles Relief & Development.png" }
  ];

  return (
    <section id="clients" className="clients">
      <div className="container">
        <div className="section-title">
          <h2>Our Clients</h2>
          <p>We've had the privilege of working with prestigious organizations and institutions.</p>
        </div>
        <div className="clients-grid">
          {clients.map((client, index) => (
            <div key={index} className="client-logo">
              <div className="logo-container">
                <img 
                  src={`/images/clients/${client.logo}`} 
                  alt={client.name}
                  title={client.name}
                  className="client-logo-img"
                  onError={(e) => {
                    // Fallback to client name if logo fails to load
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `<p>${client.name}</p>`;
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;